import { render, staticRenderFns } from "./SinglePatient.vue?vue&type=template&id=79603e0c&scoped=true"
import script from "./SinglePatient.vue?vue&type=script&lang=js"
export * from "./SinglePatient.vue?vue&type=script&lang=js"
import style0 from "./SinglePatient.vue?vue&type=style&index=0&id=79603e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79603e0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDivider,VProgressCircular})
